/**
 * A template may hold several recipients, stored the way the creator typed
 * them. mailto: expects them comma-separated without spaces, so the stored
 * value is split and rejoined before it becomes a link.
 */
export const toMailtoRecipients = (emailAddress) =>
  (emailAddress ?? "")
    .split(",")
    .map((address) => address.trim())
    .filter((address) => address !== "")
    .join(",");

/**
 * Builds a mailto: URL. Subject/body are percent-encoded — URLSearchParams
 * would turn spaces into "+", which many mail clients show literally.
 * Invalid or placeholder addresses (`#`) return null so the row stays inert.
 */
export const buildMailtoUrl = (emailAddress, subject, body) => {
  if (!emailAddress || emailAddress === "#") return null;

  const recipients = toMailtoRecipients(emailAddress);
  if (!recipients) return null;

  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);

  return params.length
    ? `mailto:${recipients}?${params.join("&")}`
    : `mailto:${recipients}`;
};
